/**
 * Private function to convert a string to a boolean, any value other than "true" (case-insensitive) will be returned as false.
 *
 * @param {item} - string or boolean value
 *
 * @returns {Boolean}
 */
function stringToBoolean(item) {
  if (!item) return false;
  return item.toLowerCase() === "true" || item.toLowerCase() === true;
}

/**
 * This passes in a json value and then builds out the runtimeConfig settings from there.
 * The json that is being loaded should have the user/password for Global or GO search, not both.
 *
 * @param {json} - json value from fetch call, used to fill out object array with correct information
 *
 * returns {object} - Object with the elasicsearch configuration settings
 */
export default function config(json) {
  if (!json) return {};
  return {
    elasticsearch: {
      host: json.ELASTICSEARCH_HOST,
      port: json.ELASTICSEARCH_PORT,
      protocol: json.ELASTICSEARCH_PROTOCOL,
      user: json.ELASTICSEARCH_USER,
      pass: json.ELASTICSEARCH_PASS,
      index: json.ELASTICSEARCH_INDEX
    },
    features: {
      images: stringToBoolean(json.FEATURE_IMAGES),
      imagesToggle: stringToBoolean(json.FEATURE_IMAGES_TOGGLE),
      tags: stringToBoolean(json.FEATURE_TAGS)
    },
    env: json.VAULT_ENV,
    sentry: {
      dsn: json.SENTRY_DSN
    }
  };
}
